import { render, staticRenderFns } from "./edit.lists-entries.page.vue?vue&type=template&id=22e20762&"
import script from "./edit.lists-entries.page.vue?vue&type=script&lang=js&"
export * from "./edit.lists-entries.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports